import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import ThemeToggle from "../components/ThemeToggle";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setBusy(true);
        try {
            await api.post("/auth/password-reset/request", { email });
            setSent(true);
        } catch (err) {
            setError(formatApiError(err?.response?.data?.detail));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-sand-50 text-ink flex items-center justify-center px-6 py-12">
            <div className="w-full max-w-md">
                <div className="flex items-center justify-between">
                    <Link to="/login" className="sp-overline" data-testid="forgot-back">← Back to sign in</Link>
                    <ThemeToggle />
                </div>
                <h1 className="text-3xl sm:text-4xl font-serif mt-6">Forgot password?</h1>
                <p className="text-ink-soft mt-2">
                    Enter your email and we'll send a link to choose a new one. The link expires in 1 hour.
                </p>

                {sent ? (
                    <div
                        className="mt-8 rounded-2xl border border-ink/10 bg-surface p-6"
                        data-testid="forgot-sent"
                    >
                        <div className="sp-overline">Check your inbox</div>
                        <p className="mt-3 text-ink-soft">
                            If an account exists for <span className="text-ink font-medium">{email}</span>, a reset link is on its way. It expires in 1 hour.
                        </p>
                        <p className="mt-3 text-sm text-ink-muted">
                            Didn't receive it? Check spam, or try again in a few minutes.
                        </p>
                        <Link to="/login" className="sp-btn-ghost w-full mt-6 text-center block" data-testid="forgot-return-login">
                            Return to sign in
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-8 space-y-6">
                        <div>
                            <label className="sp-overline" htmlFor="email">Email</label>
                            <input
                                id="email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="sp-input"
                                placeholder="you@stars.app"
                                data-testid="forgot-email"
                            />
                        </div>
                        {error && (
                            <div className="text-sm text-red-700" data-testid="forgot-error">{error}</div>
                        )}
                        <button
                            type="submit"
                            disabled={busy}
                            className="sp-btn-primary w-full"
                            data-testid="forgot-submit"
                        >
                            {busy ? "Sending…" : "Send reset link"}
                        </button>
                    </form>
                )}

                <div className="mt-6 text-sm text-ink-muted">
                    Remembered it?{" "}
                    <Link to="/login" className="sp-link text-ink" data-testid="forgot-to-login">Sign in</Link>
                </div>
            </div>
        </div>
    );
}
